import React, { useEffect } from "react";
import { renderButton, renderTextField, renderCancelButton} from "@/shared/FormUtils";
import { fetchAPI } from "@/utility/NetworkUtils";
import Loading from "@/shared/Loading";
import { Stack } from "@mui/material";

const ItemRemovalForm = ({
  formikProps,
  item,
  onClose,
  onSave
}) => {
  const [ upcomingEvents, setUpcomingEvents ] = React.useState(null);
  const [ submitting, setSubmitting ] = React.useState(false);
  const loading = upcomingEvents === null;

  useEffect(() => {
    loadUpcomingEvents()
  }, [])

  const loadUpcomingEvents = async () => {
    fetchAPI(`/webapi/items/${item.id}/upcoming_events`, (json)=> {
      if (!json.errors) {
        setUpcomingEvents(json.events)
      }
    })
  }

  const handleSave = () => {
    if(submitting) return
    setSubmitting(true)
    fetchAPI(`/webapi/items/${item.id}/create_inventory_update/`, (json) => {
      if(json.error) {
        alert(json.error)
      }else {
        onSave()
      }
      setSubmitting(false)

    }, {
      method: "POST",
      body: {
        item_inventory_log: {
          count: -1 * formikProps.values.quantity_to_be_removed,
          recieving_item: false,
        }
      }
    })
  }

  const renderButtons = () => {
    return (
      <Stack direction="row" spacing={2} justifyContent="flex-end" className="mt-4">
        {renderCancelButton("Cancel", onClose)}
        {renderButton("Save", handleSave, {color:"green", disabled: isSubmitDisabled()})}
      </Stack>
    )
  }



  const isSubmitDisabled = () => {
    return !(formikProps.values.quantity_to_be_removed && formikProps.values.quantity_to_be_removed > 0)
  }


  if(loading) {
    return (
      <Loading />
    )
  }


  
  return (
    <div className="mt-[40px]">
      <div className="font-bold pb-4">Warehouse only! Please contact warehouse personnel, if change is needed.</div>
      <div className="max-w-[254px]">
        {renderTextField(
          "Quantity to be removed",
          "quantity_to_be_removed",
          {
            type: "number",
            min: 0,
            required: true,
            fieldProperties: {
              inputProps:{ min: 0 },
              min: 0,
              type: "number",
            }
          }
        )}
      </div>
      
      {(upcomingEvents||[]).length > 0 && (
        <div className="my-6 text-black">
          <div className="text-red-500 font-bold">
            Item is currently reserved for these upcoming events.
          </div>
          <div className="mb-2">
            Alert will appear on the item.
          </div>
          {upcomingEvents.map((event, index) => {
            return (
              <div key={index}>
                <div>{event.name}</div>
              </div>
            )
          })}
        </div>
      )}
      {renderButtons()}
    </div>
  )

};

export default ItemRemovalForm;